import React from "react";
import { Wrapper } from "@/components/Wrapper";
import { BenefitsList } from "../BenefitsList";
import { PlanWrapper } from "../PlanWrapper";
import { renderPhoneBox } from "@/utils/pricing";
import { PricingContainerProps } from "../types";

export const PricingContainer = ({
  data,
  currentPlan,
  onSelectPlan,
  isStatusActive,
}: PricingContainerProps) => {
  return (
    <>
      <Wrapper>
        <PlanWrapper
          data={data}
          currentPlan={currentPlan}
          onSelectPlan={onSelectPlan}
          isStatusActive={isStatusActive}
        />
      </Wrapper>
      <div className="dynamic-benefits">
        <div className="dynamic-benefits__wrapper">
          <BenefitsList
            list={currentPlan?.benefits?.richtext?.list}
            active={true}
          />
        </div>
      </div>
      {renderPhoneBox(data)}
    </>
  );
};
